module.exports = __webpack_public_path__ + "img/lock-square.e4244064.svg";